exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-ab6b6e5e]:hover {\n  cursor: pointer;\n}\n.module-title[data-v-ab6b6e5e] {\n  background-color: #ff8535;\n  color: #fff;\n  font-size: 20px;\n  line-height: 40px;\n  margin-bottom: 15px;\n}\n.product-info[data-v-ab6b6e5e] {\n  background-color: #fff;\n  margin-bottom: 15px;\n  padding: 10px;\n  width: 100%;\n}\n.product-info table[data-v-ab6b6e5e] {\n  width: 100%;\n}\n.product-info table td[data-v-ab6b6e5e] {\n  vertical-align: top;\n}\n.product-info .badge[data-v-ab6b6e5e] {\n  vertical-align: text-bottom;\n}\n.text-left[data-v-ab6b6e5e] {\n  text-align: left;\n}\n.text-center[data-v-ab6b6e5e] {\n  text-align: center;\n}\n.text-right[data-v-ab6b6e5e] {\n  text-align: right;\n}\n.text-totals[data-v-ab6b6e5e] {\n  width: 33.333%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ab6b6e5e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ScanProduced.vue
// module id = XG+u
// module chunks = 1